import {createApp, h} from 'vue'
import {InertiaProgress} from '@inertiajs/progress'
import {createInertiaApp} from '@inertiajs/inertia-vue3'
import moment from 'moment'
import {createStore} from 'vuex'
import {createI18n} from 'vue-i18n'
import en from '@/i18n/locales/en'
import nl from '@/i18n/locales/nl'
import fr from '@/i18n/locales/fr'

import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import Maska from 'maska'

import axios from 'axios'
window.axios = axios

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

// Create store for permissions
const store = createStore({
  state: {
    permissions: Array,
  },
  mutations: {
    setPermissions(state, payload) {
      state.permissions = payload
    },
  },
  getters: {
    getPermissions: state => {
      return state.permissions
    },
    can: (state) => (value) => {
      if (value === 'pane') {
        value = 'social'
      }
      let permissions = state.permissions
      const result = Array.isArray(permissions) ? permissions.includes(value) : false
      if (result) {
        return true
      } else {
        return false
      }
    },
  },
})

//Permissions instellen bij navigation
import {Inertia} from '@inertiajs/inertia'
import {usePage} from '@inertiajs/inertia-vue3'
import find from 'lodash/find'

Inertia.on('success', (event) => {
  if (usePage().props.value.auth && usePage().props.value.auth.user) {
    store.commit('setPermissions', usePage().props.value.auth.user.permissions)
  } else {
    store.commit('setPermissions', '')
  }
})

InertiaProgress.init()

createInertiaApp({
  resolve: name => require(`./Pages/${name}`),
  title: title => title ? `${title} | Rizome - BXL` : 'Rizome - BXL',
  setup({el, App, props, plugin}) {
    const data = JSON.parse(el.dataset.page)
    const i18n = createI18n({
      locale: (data['props']['auth']['user']) ? data['props']['auth']['user']['language'] : 'en',
      fallbackLocale: 'en',
      messages: {
        en,
        nl,
        fr,
      },
    })

    //Permissions instellen bij reload van de page
    if (data['props']['auth']['user']) {
      store.commit('setPermissions', data['props']['auth']['user']['permissions'])
    }

    const swalOptions = {
      title: i18n.global.t('swal.title'),
      text: i18n.global.t('swal.sub-title'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: i18n.global.t('swal.btn-ok'),
      cancelButtonText: i18n.global.t('swal.btn-cancel'),
      customClass: {
        confirmButton: 'btn btn-indigo',
        cancelButton: 'text-red-600 hover:underline ml-4',
      },
      buttonsStyling: false,
    }

    let app = createApp({
      render: () => {
        return h(App, props)
      },
    })
    app.config.globalProperties.$moment = moment

    app.config.globalProperties.$permissions = {
      getPermission(name, fieldName) {
        let permissions = [
          {
            name: 'Bénévole',
            allowedFields: [
              'volunteer', 'date','location', 'seen',
            ],
          },
          {
            name: 'PANE',
            allowedFields: [
              'date', 'employee', 'location', 'send_field',
            ],
          },
          {
            name: 'Social',
            allowedFields: [
              'type',
              'employee',
              'cooperation',
              'date',
              'location',
              'request',
            ],
          },
          {
            name: 'Psy',
            allowedFields: [
              'type',
              'employee',
              'cooperation',
              'date',
              'location',
              'request',
            ],
          },
          {
            name: 'MDD',
            allowedFields: [
              'type',
              'employee',
              'cooperation',
              'date',
              'location',
              'request',
            ],
          },
          {
            name: 'Logement',
            allowedFields: [
              'type',
              'employee',
              'cooperation',
              'date',
              'location',
              'request',
              'status',
              'status_logement',
              'type_logement',
            ],
          },
        ]

        let permission = find(permissions, {name: name})

        if (!permission) {
          return true
        } else {
          return permission.allowedFields.includes(fieldName)
        }

      },
    }

    app.config.globalProperties.$languages = {
      getLanguages() {
        return [
          {label: 'Nederlands', value: 'nl'},
          {label: 'English', value: 'en'},
          {label: 'Français', value: 'fr'},
        ]
      },
    }

    app.config.globalProperties.$filters = {
      formatDate(value) {
        if (value) {
          return moment(String(value)).format('DD/MM/YYYY')
        }
      },
      formatDateTime(value) {
        if (value) {
          return moment(String(value)).format('DD/MM/YYYY hh:mm')
        }
      },
      fromNow(value) {
        if (value) {
          return moment(String(value)).fromNow()
        }
      },
    }

    app.config.globalProperties.$functions = {
      getDateColor(date) {
        let dateAsDate = new Date(date)
        let today = new Date()
        let orangeDate = new Date(new Date().setMonth(new Date().getMonth() + 1))
        if (dateAsDate.getTime() < today.getTime()){
          return 'danger'
        }
        if (dateAsDate.getTime() < orangeDate.getTime()){
          return 'warning'
        }
        return 'default'
      },
    }

    app.use(i18n)
      .use(plugin)
      .use(store)
      .use(VueSweetalert2, swalOptions)
      .use(Maska)
    //.component('v-select', vSelect)
      .mount(el)
  },
})
